import { ReactNode } from 'react';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import {
  createResourceLinkExtension,
  extractLastNameComponent,
  isResourceName,
} from '@spotify/confidence-core-react';

import { surfacesPlugin } from '../plugin';
import { surfaceRouteRef } from '../routes';

interface SurfaceResourceLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

const SurfaceResourceLink = ({
  name,
  text,
  className,
}: SurfaceResourceLinkProps) => {
  const routeRef = useRouteRef(surfaceRouteRef);
  const surfaceId = extractLastNameComponent(name);

  if (!routeRef || !surfaceId) {
    return <>{text}</>;
  }

  const to = routeRef({ id: surfaceId });

  return (
    <Link to={to} className={className} data-track-source-anchor="a811adca64;surface-resource-link">
      {text}
    </Link>
  );
};

export const SurfaceResourceLinkExtension = surfacesPlugin.provide(
  createResourceLinkExtension({
    id: 'surface-resource-link',
    predicate: ({ name }) => isResourceName(name, 'surfaces'),
    icon: 'surface',
    render: ({ name, text, className }) => (
      <SurfaceResourceLink name={name} text={text} className={className}  data-track-source-anchor="65c529ccc4;resource-link-extension-surface-resource-link"/>
    ),
  }),
);
